import React from "react";
import { DocumentManager } from "@/components/admin/DocumentManager";

export default function AdminServiceBulletins() {
  return (
    <DocumentManager
      title="Service Bulletins"
      subtitle="Publish service notices and updates. Assign which models they apply to and mark them accessible to customers."
      fixedType="service_bulletin"
    />
  );
}
